export const DEPARTURE_NOW = 'NOW'
export const DEPARTURE_LATER = 'DEPARTURE_LATER'
export const ARRIVAL_LATER = 'ARRIVAL_LATER'
